import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        color: '#141b33',
        cursor: 'pointer',
        padding: '10px 20px',
        background: '#ffc324',
        borderRadius: '4px',
        border: 'none',
        outline: 'none'
    }
}))
const FieldsButton = ({
    type,
    label,
    handleClick
}) => {
    const classes = useStyles();

    return (
        <button type={type} onClick={handleClick} className={classes.root}>{label}</button>
    )
}

export default FieldsButton